<template>
    <div class="row">
        <div class="col-md-10 col-md-offset-2">
            <h2 class="text-center">
                <span id="hospitalName">{{selectedHospitalName}}</span>
                <br />
                <span id="chart-title"></span>
            </h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-2">
            <br />
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Chart Information</h3>
                </div>
                <div class="panel-body">
                    <button type="button" class="btn btn-default btn-block" data-toggle="modal" data-target="#chartExplanation" tabindex="0">
                        Explanation
                    </button>
                </div>
            </div>
            <br />
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Scope</h3>
                </div>
                <div class="panel-body">
                    <select name="scope" id="scope" class="form-control" v-model="scope" @change="renderVis">
                        <option value="National" selected>National</option>
                        <option value="State">State</option>
                    </select>
                </div>
            </div>
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Year</h3>
                </div>
                <div class="panel-body">
                    <select name="year" id="year" class="form-control"  @change="renderVis" v-model="year">
                        <option  v-for="(y) in years" :key="y" :value="y"> {{ y }}</option>
                    </select>
                </div>
            </div>
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Domains</h3>
                </div>
                <div class="panel-body" style="height:150px;overflow:scroll;">
                    <div class="checkbox" v-for="(d) in domains.filter(domain=>domain != 'Financial Distress'  && domain != 'COVID-19 PHE Funding')">
                      <label>
                        <input type="checkbox" class="domain-checkbox"  checked @change="renderVis();" :value="d">
                        {{ d }}
                      </label>
                    </div>
                </div>
                <div class="panel-footer">
                    <button class="btn btn-xs btn-default" onclick="$('.domain-checkbox:input:checkbox').prop('checked', false);" @click="renderVis">Clear All</button>
                    <button class="btn btn-xs btn-default" onclick="$('.domain-checkbox:input:checkbox').prop('checked', true);" @click="renderVis">Select All</button>
                </div>
            </div>
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Actions</h3>
                </div>
                <div class="panel-body text-center">
                    <button class="btn btn-default" onclick="renderVis();">Refresh</button>
                    <a v-if="user.typecode != 'hospital'" href="" role="button" class="btn btn-default" style="color:black;" @click="loadPage('hospitals')">Change Hospital</a>
                    <a href="/vistype" class="btn btn-default" style="color: #636b6f">Start new graph</a>
                    <a href="/reporting/indicators/download" class="btn btn-default" style="color: #636b6f">Indicator definitions <span class="glyphicon glyphicon-download"></span></a>
                    <button class="btn btn-default" id="saveImage" onclick='savePNGHosp();' >Save Image <span class="glyphicon glyphicon-download"></span></button>
                    
                </div>
            </div>
            
            
        </div>

        <div class="col-md-10">
            <div id="chart">
                
            </div>
        </div>

        <!-- Modal for chartExplanation description -->
        <div id="chartExplanation" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
              <h2 class="modal-title">Chart Explanation</h2>
              </div>
                <div class="modal-body">
                <p>This graphic depicts the relative position of a CAH's financial indicators compared to other CAHs. The bars represent the hospital's percentile rank for each financial indicator. For example if your hospital is in the 66th percentile for total margin, then 34 percent of CAHs have higher total margins than your hospital, and 66 percent have lower total margins. You have the option to select national or state percentiles. You can hover over the bar to see the actual value of and median for each indicator.</p>
                </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal" tabindex="0">Close</button>
              </div>
            </div>
          </div>
        </div>
    </div>



</template>
<style>
div.newtooltip {    
    position: absolute;
    color: #000;
    padding: 5px;
    z-index: 10000;
    display: block;
    font-family: Arial,sans-serif;
    font-size: 13px;
    text-align: left;
    pointer-events: none;
    white-space: nowrap;
    user-select: none;
    background: hsla(0,0%,100%,.8);
    border: 1px solid rgba(0,0,0,.5);
    border-radius: 4px;         
}
.nvd3 text {
    color: black;
}
.value {
    font-weight: bold;
}
</style>

<script type="module">

</script>

<script setup>

import { ref, onMounted, toRaw } from 'vue'
import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'


const {  restart, loadPage } = useVisualizationsStore()
const { user, selectedHospitalName, selectedHospitalId , chartType, arrindicators, groups, domains, years, defaultYear} = storeToRefs(useVisualizationsStore())

const year = ref(defaultYear);
//const domain = ref();
const scope = ref('National');

    const renderVis = () => {

                var anySelected = $('.domain-checkbox:checkbox:checked').length;
                if (anySelected > 0) {
                    $('#chart').html('');
                    // starting loading spinner
                    var target = document.getElementById('chart');
                    var spinner = new Spinner().spin();
                    target.appendChild(spinner.el);

                    // gathering data for query
                    var indicator = "0";
                    var year = document.getElementById('year').value;
                    var cahid = toRaw(selectedHospitalId.value);
                    var scope = document.getElementById('scope').value;
                    var checked = $('.domain-checkbox:checkbox:checked');
                    var domains = [];
                    for (var i = 0; i < checked.length; i++) {
                        domains.push(checked[i].value);
                    }
                    
                    // assembling query
                    var query = {
                        'indicator': indicator,
                        'year': year,
                        'cahid': cahid,
                        'scope': scope,
                        'domains': domains
                    };
                    console.log(query);
                    var query_serialized = jQuery.param(query);

                    // making ajax call to endpoint
                    $.get('/percentile?' + query_serialized,function(response){
                        // stopping spinner
                        spinner.stop();
                        // passing endpoint response to hospital dashboard
                        HospitalDashboard(response);
                        // editing chart title
                        document.getElementById('chart-title').innerHTML = query.year + " " + query.scope + ' Percentiles';
                    });
                } else {
                    // clear
                    $('#chart svg').html('<text x="40" y="35" class="heavy">No domains selected.</text>');
                    console.log('here');
                }
            }

onMounted(() => {

    renderVis();

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    //gtag('config', '{{ config('app.ga_token') }}');
    var myhosp = "";
    if (user.typecode == 'hospital') {
       myhosp = user.hospital;
    }
    gtag('set', 'user_data', {

    });

    gtag('event', 'show_visualization', {
        'indicator': "",
        'type': "hospital-dashboard",
        'username': "{{ Auth::user()->username }}",
        'full_query': "",
        'hospital_dimension': "",   
        'hospital_state': myhosp,
      });


});


</script>